import { ApiClientData } from "../../../libs/firebase/ApiClientData";
import CollectionLoader from "../General/CollectionLoader";
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { PropertyData } from "../Property/PropertyData";
import { CompanyIntegrationConnectionData } from "./CompanyIntegrationConnectionData";

export type AccessTokenScope =
  | "read:all:contractors"
  | "read:all:collections"
  | "read:all:members"
  | "read:all:tasks"
  | "read:all:units"
  | "read:client:tasks"
  | "create:tasks"
  | "read:all:bookings"
  | "read:all:bookingUnits"
  | "read:all:bookingUnitStatus"
  | "write:client:properties"
  | "write:all:units"
  | "write:all:collections";

export const AllAccessTokenScopes: AccessTokenScope[] = [
  "read:all:bookings",
  "read:all:bookingUnits",
  "read:all:bookingUnitStatus",
  "read:all:collections",
  "read:all:contractors",
  "read:all:members",
  "read:all:tasks",
  "read:all:units",
  "read:client:tasks",
  "create:tasks",
  "write:client:properties",
  "write:all:units",
  "write:all:collections"
];

export const ReadAccessTokenScopes: AccessTokenScope[] = AllAccessTokenScopes.filter((scope) => scope.startsWith("read"));
export const WriteAccessTokenScopes: AccessTokenScope[] = AllAccessTokenScopes.filter((scope) => scope.startsWith("create") || scope.startsWith("write"));

export class CompanyIntegrationData extends FirebaseData {
  apiClient?: ApiClientData = undefined;

  properties: PropertyData[] = [];
  scopes: AccessTokenScope[] = [];

  connections: CollectionLoader<CompanyIntegrationConnectionData>;

  constructor(id: string, collection: string, parent?: FirebaseData) {
    super(id, collection, parent);
    this.connections = new CollectionLoader("connections", this, CompanyIntegrationConnectionData);
  }

  setup(data: any) {
    this.apiClient = typeof data.apiClientID === "string" ? LocalData.apiClients.addData(data.apiClientID) : undefined;
    this.properties = Array.isArray(data.properties) ? data.properties.map((pId: string) => LocalData.properties.addData(pId)) : [];
    this.scopes = Array.isArray(data.scopes) ? data.scopes : [];

    super.setup(data);
  }
}
